import {
  pList,
  rMadenSahalariBilgi,
  rMadenSahalariGenelBilgi,
  rValue,
} from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';
import { rMadenSahalariBilgi_RawData } from '../../../../api/models/rMadenSahalariBilgi';
import { rMadenSahalariGenelBilgi_RawData } from '../../../../api/models/rMadenSahalariGenelBilgi';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_MADENSAHALARIGENELBILGI,
    new Api.Bilgi.MadenSahalariGenelBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rMadenSahalariGenelBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rMadenSahalariGenelBilgi> =>
  ActionFunctions.action_async_complete_api<rMadenSahalariGenelBilgi>(
    ActionSubTypes.API_MADENSAHALARIGENELBILGI,
    { Data: new Collection(((data?.Value?.Data as unknown) as any) || []) },
    error
  );
